export default "__VITE_ASSET__e7042e62__"